const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

/** A MIDI pitch number as the note a singer would recognise, e.g. 60 -> `C4`. */
export const pitchToNoteName = (pitch: number) => {
  const rounded = Math.round(pitch);
  const octave = Math.floor(rounded / 12) - 1;

  return `${NOTE_NAMES[((rounded % 12) + 12) % 12]}${octave}`;
};

/**
 * Roughly the range a voice covers. Readings outside it are an octave error or background noise
 * rather than singing, and would stretch a measured range to something nobody can sing.
 */
export const LOWEST_SINGABLE_PITCH = 36;
export const HIGHEST_SINGABLE_PITCH = 96;
